import { tryFetch, type HttpResponse } from '@/modules/services/http'
import { HttpMethod } from '@/modules/services/http/types/http.enums'
import { FilterErrorCode } from '../models/filter.enums'
import type { FilterResponse } from '../models/filter.model'

const BASE_URL = import.meta.env.VITE_MAIN_BASE_URL

const getFilterPreset = async (): Promise<HttpResponse<FilterResponse, FilterErrorCode>> =>
  await tryFetch<FilterResponse, FilterErrorCode>(HttpMethod.Get, BASE_URL, ['filter', 'preset'], {
    view: true,
  })

export const filterApi = {
  getFilterPreset,
}
